import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import translation from "utils/i18n/locales/en/translation.json";
import translationOrg from "utils/i18n/locales/enOrg/translation.json";

export const resources = {
  en: {
    translation,
  },
  enOrg: {
    translation: translationOrg,
  },
} as const;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV !== "production",
    lng: "en",
    resources,
    // Configure namespace fallbacks - if key not found in enOrg, fallback to en
    fallbackNS: false,
    // Enable fallbacks
    returnEmptyString: false,
    // Custom fallback order for enOrg -> en
    fallbackLng: {
      enOrg: ["en"],
      default: ["en"],
    },
  });

export default i18n;
